import { axios } from "../../../lib/axios";

export const getDiseaseForPatient = (patientId) => {
    return axios.get(`disease/${patientId}`);
}